"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const ButtonContainer_1 = require("../ButtonContainer");
exports.EmailCanvasBlockContentSlotButton = ({ contentCanBeChanged, contentItem, contentFeed, contentSlotNumber, }) => {
    if (typeof contentSlotNumber !== 'number' ||
        !contentFeed ||
        !contentFeed.contentSystem) {
        return null;
    }
    const prettyLabel = `Slot #${contentSlotNumber + 1}`;
    const prettyTooltip = (react_1.default.createElement(react_1.default.Fragment, null,
        "Using content from ",
        react_1.default.createElement("u", null, prettyLabel),
        " in ",
        react_1.default.createElement("u", null, contentFeed.name),
        " (",
        react_1.default.createElement("u", null, contentFeed.contentSystem.name),
        ")"));
    if (!contentItem || !contentFeed) {
        return null;
    }
    const disabled = !contentCanBeChanged;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
            react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { tooltip: prettyTooltip, 
                //   color="primary"
                osysIcon: "slot", 
                //   faIcon={faCabinetFiling}
                osysName: "EmailCanvasBlockContentSlotButton", disabled: true || disabled, onClick: () => {
                    if (disabled) {
                    }
                } }, prettyLabel))));
};
//# sourceMappingURL=ContentSlotButton.js.map